import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";

interface GuestPDFViewerControlsProps {
  numPages: number | null;
  currentPage: number;
  setCurrentPage: (page: number | ((prevPage: number) => number)) => void;
}

const GuestPDFViewerControls: React.FC<GuestPDFViewerControlsProps> = ({
  numPages,
  currentPage,
  setCurrentPage,
}) => {
  const [pageInput, setPageInput] = useState<string>(currentPage.toString());

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageInput(e.target.value);
  };

  const handlePageInputBlur = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && numPages && pageNumber >= 1 && pageNumber <= numPages) {
      setCurrentPage(pageNumber);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handlePageInputBlur();
      (e.target as HTMLInputElement).blur();
    }
  };

  return (
    <div className="flex gap-2 mb-4 justify-start items-center">
      {numPages && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline-secondary"
            className="btn_sm"
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage <= 1}
          >
            Previous
          </Button>
          <div className="flex items-center">
            <Form.Control
              type="number"
              value={pageInput}
              onChange={handlePageInputChange}
              onBlur={handlePageInputBlur}
              onKeyPress={handlePageInputKeyPress}
              className="w-16 text-center form-control-sm"
              min="1"
              max={numPages}
            />
            <span className="text-sm min-w-10 text-gray-500 ml-1 flex flex-col">{"/ " + numPages}</span>
          </div>
          <Button
            variant="outline-secondary"
            className="btn_sm"
            onClick={() => numPages && setCurrentPage((p) => Math.min(numPages, p + 1))}
            disabled={!numPages || currentPage >= numPages}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default GuestPDFViewerControls;